import PlaceHolder from '@/components/icons/shop/PlaceHolder';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

interface HotplaceImageProps {
    title: string;
    urlPreview: string | null | undefined;
}

const HotplaceImage = ({ title, urlPreview }: HotplaceImageProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={clsx(styles['panel__image'], 'focus-border', {
                [styles['panel__image--placeholder']]: !urlPreview,
            })}
            data-interactive
            aria-label={urlPreview ? t('list_type.detail.tts.detail_image', { title }) : title}
        >
            {urlPreview ? (
                <img src={urlPreview} alt={title} loading="lazy" />
            ) : (
                <div className={styles['panel__image-skeleton']} aria-hidden="true">
                    <PlaceHolder />
                </div>
            )}
        </div>
    );
};

export default HotplaceImage;
